// © Microsoft Corporation. All rights reserved.

/**
 * Utility method to extract query string param in url.
 * @param name - Query param name
 * @returns Query param value
 */
export function getQueryParameterByName(locationHref: string, name: string): string {

    const nameRegEx = name.replace(/[[\]]/g, "\\$&");
    const regex: any = new RegExp("[?&]" + nameRegEx + "(=([^&#]*)|&|#|$)");

    const queryNameValueMatches: any = regex.exec(locationHref);
    if (!queryNameValueMatches) {
        return null;
    }

    // the second group would contain the value of the param
    const queryValue = queryNameValueMatches[2];

    return decodeURIComponent(queryValue.replace(/\+/g, " ")) || "";
}